import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BaseNotificationPanel from '@/components/base/BaseNotificationPanel.vue'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'DemoModeInformer' },
  __name: 'DemoModeInformer',
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const emit = __emit



const { t } = useI18n()
const route = useRoute()

const isOnDashboard = computed(() => route.name === 'dashboard')
const to = computed(() => (!isOnDashboard.value ? { name: 'dashboard' } : {}))

const scrollToSteps = (): void => {
  emit('close')

  setTimeout(() => {
    const steps = document.querySelector('#registration-steps')
    steps?.scrollIntoView({ behavior: 'smooth' })
  }, 200)
}

return (_ctx: any,_cache: any) => {
  const _component_VIcon = _resolveComponent("VIcon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(BaseNotificationPanel, {
    status: "warning",
    class: "mb-4"
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createTextVNode(_toDisplayString(_unref(t)('registration_flow.notification.info_generic')), 1)
      ]),
      _createVNode(_component_RouterLink, {
        class: "mt-1 inline-flex items-center justify-start fill-current font-medium text-primary hover:underline",
        to: to.value,
        onClick: _withModifiers(scrollToSteps, ["prevent"])
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "link", {}, () => [
            _createTextVNode(_toDisplayString(_unref(t)('registration_flow.notification.action_generic')), 1)
          ]),
          _createVNode(_component_VIcon, {
            icon: "$arrow-right",
            class: "text-primary"
          })
        ]),
        _: 3
      }, 8, ["to"])
    ]),
    _: 3
  }))
}
}

})